
    import * as React from 'react';

    const Clock12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><g fillRule="evenodd"><path d="M6.155 5.843V3H5.5v3.498H9v-.655z" /><path d="M6 11A5 5 0 106 1a5 5 0 000 10zm0-.75a4.25 4.25 0 110-8.5 4.25 4.25 0 010 8.5z" fillRule="nonzero" /></g></svg>
        </div>
      );
    };

    Clock12.displayName = 'Clock12';

    export default Clock12;
  